/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetThreadsSettingsForExplorerQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetThreadsSettingsForExplorerQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly defaultDataConnection: {
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    } | null;
    readonly exploreAgentSettings: {
      readonly __typename: "ExploreAgentSettings";
      readonly id: c.ExploreAgentSettingsId;
      readonly explorerDataSource: Types.DataSourceFilter;
      readonly explorerDefaultDataConnection: {
        readonly __typename: "DataConnection";
        readonly id: c.DataConnectionId;
      } | null;
    };
  };
};

export type GetThreadsSettingsForEditorQueryVariables = Types.Exact<{
  orgId: Types.Scalars["OrgId"]["input"];
}>;

export type GetThreadsSettingsForEditorQuery = {
  readonly __typename: "Query";
  readonly orgById: {
    readonly __typename: "Org";
    readonly id: c.OrgId;
    readonly defaultDataConnection: {
      readonly __typename: "DataConnection";
      readonly id: c.DataConnectionId;
    } | null;
    readonly exploreAgentSettings: {
      readonly __typename: "ExploreAgentSettings";
      readonly id: c.ExploreAgentSettingsId;
      readonly editorEnabled: boolean;
      readonly editorDataSource: Types.DataSourceFilter;
      readonly editorDefaultDataConnection: {
        readonly __typename: "DataConnection";
        readonly id: c.DataConnectionId;
      } | null;
    };
  };
};

export const GetThreadsSettingsForExplorerDocument = /*#__PURE__*/ gql`
  query GetThreadsSettingsForExplorer($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      defaultDataConnection {
        id
      }
      exploreAgentSettings {
        id
        explorerDataSource
        explorerDefaultDataConnection {
          id
        }
      }
    }
  }
`;

/**
 * __useGetThreadsSettingsForExplorerQuery__
 *
 * To run a query within a React component, call `useGetThreadsSettingsForExplorerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsSettingsForExplorerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsSettingsForExplorerQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetThreadsSettingsForExplorerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetThreadsSettingsForExplorerQuery,
    GetThreadsSettingsForExplorerQueryVariables
  > &
    (
      | {
          variables: GetThreadsSettingsForExplorerQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetThreadsSettingsForExplorerQuery,
    GetThreadsSettingsForExplorerQueryVariables
  >(GetThreadsSettingsForExplorerDocument, options);
}
export function useGetThreadsSettingsForExplorerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetThreadsSettingsForExplorerQuery,
    GetThreadsSettingsForExplorerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetThreadsSettingsForExplorerQuery,
    GetThreadsSettingsForExplorerQueryVariables
  >(GetThreadsSettingsForExplorerDocument, options);
}
export function useGetThreadsSettingsForExplorerSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetThreadsSettingsForExplorerQuery,
    GetThreadsSettingsForExplorerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetThreadsSettingsForExplorerQuery,
    GetThreadsSettingsForExplorerQueryVariables
  >(GetThreadsSettingsForExplorerDocument, options);
}
export type GetThreadsSettingsForExplorerQueryHookResult = ReturnType<
  typeof useGetThreadsSettingsForExplorerQuery
>;
export type GetThreadsSettingsForExplorerLazyQueryHookResult = ReturnType<
  typeof useGetThreadsSettingsForExplorerLazyQuery
>;
export type GetThreadsSettingsForExplorerSuspenseQueryHookResult = ReturnType<
  typeof useGetThreadsSettingsForExplorerSuspenseQuery
>;
export type GetThreadsSettingsForExplorerQueryResult = Apollo.QueryResult<
  GetThreadsSettingsForExplorerQuery,
  GetThreadsSettingsForExplorerQueryVariables
>;
export const GetThreadsSettingsForEditorDocument = /*#__PURE__*/ gql`
  query GetThreadsSettingsForEditor($orgId: OrgId!) {
    orgById(orgId: $orgId) {
      id
      defaultDataConnection {
        id
      }
      exploreAgentSettings {
        id
        editorEnabled
        editorDataSource
        editorDefaultDataConnection {
          id
        }
      }
    }
  }
`;

/**
 * __useGetThreadsSettingsForEditorQuery__
 *
 * To run a query within a React component, call `useGetThreadsSettingsForEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetThreadsSettingsForEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetThreadsSettingsForEditorQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useGetThreadsSettingsForEditorQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetThreadsSettingsForEditorQuery,
    GetThreadsSettingsForEditorQueryVariables
  > &
    (
      | { variables: GetThreadsSettingsForEditorQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetThreadsSettingsForEditorQuery,
    GetThreadsSettingsForEditorQueryVariables
  >(GetThreadsSettingsForEditorDocument, options);
}
export function useGetThreadsSettingsForEditorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetThreadsSettingsForEditorQuery,
    GetThreadsSettingsForEditorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetThreadsSettingsForEditorQuery,
    GetThreadsSettingsForEditorQueryVariables
  >(GetThreadsSettingsForEditorDocument, options);
}
export function useGetThreadsSettingsForEditorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetThreadsSettingsForEditorQuery,
    GetThreadsSettingsForEditorQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetThreadsSettingsForEditorQuery,
    GetThreadsSettingsForEditorQueryVariables
  >(GetThreadsSettingsForEditorDocument, options);
}
export type GetThreadsSettingsForEditorQueryHookResult = ReturnType<
  typeof useGetThreadsSettingsForEditorQuery
>;
export type GetThreadsSettingsForEditorLazyQueryHookResult = ReturnType<
  typeof useGetThreadsSettingsForEditorLazyQuery
>;
export type GetThreadsSettingsForEditorSuspenseQueryHookResult = ReturnType<
  typeof useGetThreadsSettingsForEditorSuspenseQuery
>;
export type GetThreadsSettingsForEditorQueryResult = Apollo.QueryResult<
  GetThreadsSettingsForEditorQuery,
  GetThreadsSettingsForEditorQueryVariables
>;
